import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const ProjectDetail = lazy(() => import('../pages/project/page'));
const Clients = lazy(() => import('../pages/clients/page'));
const Chat = lazy(() => import('../pages/chat/page'));
const Meetings = lazy(() => import('../pages/meetings/page'));
const Notifications = lazy(() => import('../pages/notifications/page'));
const Settings = lazy(() => import('../pages/settings/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Login = lazy(() => import('../pages/login/page'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/',
    element: <ProtectedRoute><Home /></ProtectedRoute>
  },
  {
    path: '/project/:id',
    element: <ProtectedRoute><ProjectDetail /></ProtectedRoute>
  },
  {
    path: '/clients',
    element: <ProtectedRoute><Clients /></ProtectedRoute>
  },
  {
    path: '/chat',
    element: <ProtectedRoute><Chat /></ProtectedRoute>
  },
  {
    path: '/meetings',
    element: <ProtectedRoute><Meetings /></ProtectedRoute>
  },
  {
    path: '/notifications',
    element: <ProtectedRoute><Notifications /></ProtectedRoute>
  },
  {
    path: '/settings',
    element: <ProtectedRoute><Settings /></ProtectedRoute>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
